import {
  ReactElement,
  useEffect,
  useState,
  useCallback,
  useContext,
} from "react";

import TotpQrCodeContext from "../contexts/TotpQrCodeContext";

import useEnrollTotpFactor from "hooks/useEnrollTotpFactor";
import useAuthEnrollTotpFactor from "pages/register/hooks/useAuthEnrollTotp";

import AuthTransactionContext from "pages/register/contexts/AuthTransactionContext";
import { QrCodeData } from "../types/qrCodeData";
import {
  AuthTransaction,
  StatusEnum,
} from "pages/register/types/authTransaction";

const initialQrCodeData = (
  transaction?: AuthTransaction | undefined,
): QrCodeData => {
  if (transaction && transaction.status === StatusEnum.MfaEnrollActivate) {
    const totpFactor = transaction.data._embedded?.factor;
    if (totpFactor) {
      return totpFactor._embedded?.activation;
    }
  }

  return {
    sharedSecret: "",
    _links: {
      qrcode: {
        href: "",
      },
    },
  };
};

const TotpQrCodeProvider = ({
  children,
}: {
  children: ReactElement;
}): ReactElement => {
  const { mutate: requestEnrollTotp, data: enrollTotpFactor } =
    useEnrollTotpFactor();
  const { mutate: authEnrollTotp, data: authTransaction } =
    useAuthEnrollTotpFactor();
  const { transaction } = useContext(AuthTransactionContext);
  const totpFactor = transaction
    ? authTransaction?.data._embedded?.factor
    : enrollTotpFactor;

  const [qrCodeData, setQrCodeData] = useState<QrCodeData>(
    initialQrCodeData(transaction),
  );

  const resetQrCodeData = useCallback(
    () => setQrCodeData(initialQrCodeData()),
    [setQrCodeData],
  );

  useEffect(() => {
    if (!totpFactor) return;

    const newQrCodeData: QrCodeData = totpFactor?._embedded?.activation;
    setQrCodeData(newQrCodeData);
  }, [totpFactor]);

  return (
    <TotpQrCodeContext.Provider
      value={{
        qrCodeData,
        requestEnrollTotp,
        authEnrollTotp,
        resetQrCodeData,
      }}
    >
      {children}
    </TotpQrCodeContext.Provider>
  );
};

export default TotpQrCodeProvider;
